import React, { ComponentProps, useCallback } from 'react'
import TextButton from 'LuxKit/Button/TextButton'
import { useAppDispatch } from 'hooks/reduxHooks'
import { addToUserCart } from 'actions/UserCartActions'
import { initialiseCheckout } from 'actions/CheckoutActions'
import { navigateToCheckout } from 'checkout/actions/navigateActions'
import OfferCheckoutButton from './OfferCheckoutButton'
import { isFlightItem } from 'lib/checkout/checkoutUtils'

interface Props extends Omit<ComponentProps<typeof TextButton>, 'kind' | 'children'> {
  packageView: App.OfferPackageOptionView
  addToCartAndKeepBrowsing?: boolean
  overrideRooms?: Array<App.RoomOccupants | App.Occupants>
  onSubmit?: () => void
}

function OfferSelectPackageButton(props: Props) {
  const {
    packageView,
    addToCartAndKeepBrowsing,
    onSubmit,
    overrideRooms,
    ...rest
  } = props

  const dispatch = useAppDispatch()

  const onProceedToBooking = useCallback((items: Array<App.Checkout.AnyItem>) => {
    const flights = items.some(isFlightItem)
    if (flights) {
      // Pick regular flow and final decision to pay or only add to cart to be made at end of flight selection
      dispatch(initialiseCheckout(items, { mode: 'vertical-select' }))
      dispatch(navigateToCheckout({ skipSpoofedModal: true }))
    } else {
      dispatch(addToUserCart(items))
    }
  }, [dispatch])

  return (
    <OfferCheckoutButton
      {...rest}
      kind="primary"
      onSubmit={onSubmit}
      overrideRooms={overrideRooms}
      packageView={packageView}
      onProceedToBooking={onProceedToBooking}
    >
      Select package
    </OfferCheckoutButton>
  )
}

export default OfferSelectPackageButton
